export default __webpack_public_path__ + "static/media/mobile_apiaries_image_uk.7b51cf40.png";